import React from 'react';
import { FolderPlus } from 'lucide-react';

const SFTPDirectoryManagement = () => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-sm">
      <div className="p-6 border-b border-slate-700">
        <div className="flex items-center">
          <FolderPlus className="w-6 h-6 text-blue-400 mr-3" />
          <div>
            <h2 className="text-xl font-semibold text-slate-200">SFTP Directory Management</h2>
            <p className="text-slate-400 mt-1">Manage directories and permissions for SFTP users</p>
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="text-center py-12">
          <FolderPlus className="w-16 h-16 text-slate-600 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-slate-300 mb-2">SFTP Directory Management</h3>
          <p className="text-slate-400">This page will contain SFTP directory management functionality.</p>
        </div>
      </div>
    </div>
  );
};

export default SFTPDirectoryManagement;